import React from "react";
import CheckMultiplePermission from "../../roles/CheckMultiplePermission";
import { MenuSeparator } from "../../navigation/styles";
import MenuItem from "../../metis/MenuItem";
import { NavLink } from "react-router-dom";
import UserIcon from "../../dashboard/UserIcon";
import MenuLink from "../../metis/MenuLink";

const UserManage = () => {
      return (
            <>
                  <CheckMultiplePermission
                        permissions={[
                              "user-list",
                              "user-create",
                              "user-edit",
                              "user-show",
                              "role-list",
                              "role-create",
                              "role-edit",
                              "role-delete",
                              "customer-list",
                              "customer-create",
                              "customer-edit",
                              "customer-delete",
                              "customer-enquiry-list",
                              "customer-enquiry-edit",
                              "customer-enquiry-create",
                              "customer-enquiry-show",
                        ]}
                  >
                        <MenuSeparator>User Manages</MenuSeparator>

                        <CheckMultiplePermission
                              permissions={[
                                    "user-list",
                                    "user-create",
                                    "user-edit",
                                    "user-show",
                                    "role-list",
                                    "role-create",
                                    "role-edit",
                                    "role-delete",
                              ]}
                        >
                              <MenuItem
                                    title="User Manage"
                                    icon={<UserIcon />}
                                    links={[
                                          "/dashboard/users",
                                          "/dashboard/users/create",
                                          "/dashboard/users/:userId/edit",
                                          "/dashboard/users/:userId/show",
                                    ]}
                              >
                                    <CheckMultiplePermission
                                          permissions={[
                                                "user-list",
                                                "user-create",
                                                "user-edit",
                                                "user-delete",
                                          ]}
                                    >
                                          <li>
                                                <NavLink to="/dashboard/users">
                                                      All User
                                                </NavLink>
                                          </li>
                                    </CheckMultiplePermission>
                                    <CheckMultiplePermission
                                          permissions={[
                                                "role-list",
                                                "role-create",
                                                "role-edit",
                                                "role-delete",
                                          ]}
                                    >
                                          <li>
                                                <NavLink to="/dashboard/roles">
                                                      Role & Permission
                                                </NavLink>
                                          </li>
                                    </CheckMultiplePermission>
                              </MenuItem>
                        </CheckMultiplePermission>

                        <CheckMultiplePermission
                              permissions={[
                                    "customer-list",
                                    "customer-create",
                                    "customer-edit",
                                    "customer-delete",
                                    "customer-enquiry-list",
                                    "customer-enquiry-edit",
                                    "customer-enquiry-create",
                                    "customer-enquiry-show",
                              ]}
                        >
                              <MenuItem
                                    title="Customer Manage"
                                    icon={<UserIcon />}
                                    links={[
                                          "/dashboard/users",
                                          "/dashboard/users/create",
                                          "/dashboard/users/:userId/edit",
                                          "/dashboard/users/:userId/show",
                                    ]}
                              >
                                    <CheckMultiplePermission
                                          permissions={[
                                                "customer-list",
                                                "customer-create",
                                                "customer-edit",
                                                "customer-delete",
                                          ]}
                                    >
                                          <MenuLink
                                                link="/dashboard/users"
                                                title="All Customers"
                                                links={[
                                                      "/dashboard/users",
                                                      "/dashboard/users/create",
                                                      "/dashboard/users/:userId/edit",
                                                      "/dashboard/users/:userId/show",
                                                ]}
                                          />
                                    </CheckMultiplePermission>
                                    <CheckMultiplePermission
                                          permissions={[
                                                "customer-enquiry-list",
                                                "customer-enquiry-edit",
                                                "customer-enquiry-create",
                                                "customer-enquiry-show",
                                          ]}
                                    >
                                          <li>
                                                <NavLink to="/dashboard/customer-enquiries">
                                                      Customer Enquiry
                                                </NavLink>
                                          </li>
                                    </CheckMultiplePermission>
                              </MenuItem>
                        </CheckMultiplePermission>
                  </CheckMultiplePermission>
            </>
      );
};

export default UserManage;
